import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import FormInput from "../molecules/FormInput";
import { FormEvent, useState } from "react";
import { AuthService, UserService } from "../../services/api";
import { useGlobalContext } from "../../stores/Global";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { UpdateUserLanguageLanguageEnum } from "../../services/swagger";

interface EmailConfirmationDialogProps {
  open: boolean;
  login: string;
  password: string;
  handleOTP: () => void;
  handleClose: (success: boolean) => void;
}

export default function EmailConfirmationDialog(
  props: EmailConfirmationDialogProps
) {
  const { t } = useTranslation("EmailConfirmationDialog");
  const { context, setContext } = useGlobalContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setLoading(true);
    const res = await AuthService.login({
      loginBody: { login: props.login, password: props.password },
      emailCode: code,
    });
    setLoading(false);
    if (res?.data?.success) {
      props.handleClose(true);
      localStorage.setItem("authToken", res.data.data?.token || "");
      if (res?.data?.data?.otpRequired) {
        return props.handleOTP();
      }
      await UserService.updateUserLanguage({
        language: context.language as UpdateUserLanguageLanguageEnum,
      });
      setContext({ ...context, user: res.data.data?.user });
      navigate("/");
    }
  };

  return (
    <Dialog
      onClose={loading ? undefined : props.handleClose}
      open={props.open}
      component="form"
      onSubmit={handleSubmit}
    >
      <DialogTitle>
        <Typography variant="h4" gutterBottom>
          {t("EmailConfirmation")}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 500 }}>
        <Typography mb={4}>{t("PleaseEnterCode")}</Typography>
        <FormInput
          label={t("ConfirmationCode")}
          field="code"
          type="string"
          value={code}
          onChange={(value) => setCode(value as string)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          variant="outlined"
          onClick={loading ? undefined : () => props.handleClose(false)}
          disabled={loading}
        >
          {t("Cancel")}
        </Button>
        <Button type="submit" variant="contained" loading={loading}>
          {t("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
